import * as Actions from '../../actions/category';

const initialState = {
    data: [],
    isLoading: false,
    isLoaded : false,
    error: false
};

const getCategoryReducer = (state = initialState, action) => {
    switch (action.type) {
        case Actions.GET_CATEGORIES: {
            return {
                ...state,
                isLoading: true,
                error: false
            };
        }
        case Actions.GET_CATEGORIES_SUCCESS: {
            return {
                ...state,
                data: action.payload,
                isLoading: false,
                isLoaded: true,
                error: false
            };
        }
        case Actions.GET_CATEGORIES_ERROR: {
            return {
                ...state,
                isLoading: false,
                isLoaded: true,
                error: action.error
            };
        }
            
       
        case Actions.ADD_CATEGORY: {
            return {
                ...state,
                isLoading: true,
                error: false
            };
        }
        case Actions.ADD_CATEGORY_SUCCESS: {
            return {
                ...state,
                data: [action.payload, ...state.data],
                isLoading: false,
                error: false
            };
        }
        case Actions.ADD_CATEGORY_ERROR: {
            return {
                ...state,
                isLoading: false,
                error: action.error
            };
        }
        case Actions.UPDATE_CATEGORY: {
            return {
                ...state,
                isLoading: true,
                error: false
            };
        }
        case Actions.UPDATE_CATEGORY_SUCCESS: {

            const index=state.data.findIndex(p => p._id===action.payload._id)
            state.data[index]= action.payload
            return {
                ...state,
                isLoading: false,
                error: false
            };
        }
        case Actions.UPDATE_CATEGORY_ERROR: {
            return {
                ...state,
                isLoading: false,
                error: action.error
            };
        }
            
        case Actions.REORDER_CATEGORIES: {
            return {
                ...state,
                isLoading: true,
                error: false
            };
        }
        case Actions.REORDER_CATEGORIES_SUCCESS: {
            const newData=action.payload.list.map(element => {
                let element2=state.data.find((pt) => {return pt._id===element._id})
                if(element2) {
                    element2.order=element.order
                    return element2
                }
                else
                    return element

            });
            return {
                ...state,
                data: newData,
                isLoading: false,
                error: false
            };
        }
        case Actions.REORDER_CATEGORIES_ERROR: {
            return {
                ...state,
                isLoading: false,
                error: action.error
            };
        }
            
        case Actions.DELETE_CATEGORY: {
            return {
                ...state,
                isLoading: true,
                error: false
            };
        }
        case Actions.DELETE_CATEGORY_SUCCESS: {
            return {
                ...state,
                data: state.data.filter(p => p._id !== action.payload),
                isLoading: false,
                error: false
            };
        }
        case Actions.DELETE_CATEGORY_ERROR: {
            return {
                ...state,
                isLoading: false,
                error: action.error
            };
        }
            
            
        default: {
            return state;
        }
    }
};

export default getCategoryReducer 